import React from 'react'
import styled from '@emotion/styled'
import { colors, font } from '@mobi/component-library/Foundations'
import type { Ticket } from '@core/Areas/AccountActivity/types'
import { Money } from '@core/Components/Text/Money'

export const BonusBet: React.FC<Pick<Ticket, 'investment'>> = ({
  investment: { bonusBet, total, bonusType },
}) =>
  bonusBet && bonusBet > 0 && bonusType ? (
    <div>
      <WrapperRowStyled type='bonus' data-testid='bonus-bet'>
        <div>{bonusType === 'BonusBet' ? 'Bonus Bet' : 'Bonus Cash'}</div>
        <div>
          <Money amount={-bonusBet} />
        </div>
      </WrapperRowStyled>
      <WrapperRowStyled type='amount' data-testid='amount-paid'>
        <div>Amount Paid</div>
        <div>
          <Money amount={total - bonusBet} />
        </div>
      </WrapperRowStyled>
    </div>
  ) : null

const WrapperRowStyled = styled.div(({ type }: { type: string }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  color: type === 'amount' ? colors.black : colors.success[600],
  fontFamily: font.family.primary,
  fontSize: font.size.md.fontSize,
  lineHeight: font.size.md.lineHeight,
  fontWeight: font.weight.regular,
  marginTop: type === 'amount' ? '0.8rem' : 0,

  'div:nth-of-type(2)': {
    fontWeight: font.weight.medium,
  },
}))
